import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import CalculatorContextProvider from "context/Calculator";
import PasswordProtectionContextProvider from "context/PasswordProtection";

import reportWebVitals from "./reportWebVitals";

import App from "./App";

import "./index.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <PasswordProtectionContextProvider>
      <CalculatorContextProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </CalculatorContextProvider>
    </PasswordProtectionContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
